import { render, staticRenderFns } from "./RichTextNormal.vue?vue&type=template&id=a9c638d6&"
import script from "./RichTextNormal.vue?vue&type=script&lang=js&"
export * from "./RichTextNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports